import axios from "axios";
import { createTransactionID } from "../utils";


const win: any = window;
var errorPage = win["errorPageURL"];
let apigeeToken = window.location.href.includes("localhost") ? 'dO0gFIKoeSEnqVB2K5AdGHat7KWE' : win["apigeeclientToken"];
// let bmToken = window.location.href.includes("localhost") ? process.env.REACT_APP_DEV_JWT_TOKEN : win["jwtToken"];
let bmToken = win["jwtToken"];
const apigeeBaseURL = window.location.href.includes("localhost") ? "https://apisit.mobily.com.sa/api" : win["apigee_base_api_url"];
const cem_key = window.location.href.includes("localhost") ? 'liCENcCCGpHUsEPHNhySYGXCnmhwzZ' : win["CEM_KEY"];


const apigeeConfig = {
  api: {
    baseURL: apigeeBaseURL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: '',
      'x-transaction-id': createTransactionID(),
      channel: "PORTAL",
      "cem-key": cem_key
    },
  },
}

export const apigeeSimpleApi = axios.create();
export const apigeeApi = axios.create({ ...apigeeConfig.api });
export const apigee = axios.create({ ...apigeeConfig.api });

apigeeApi.defaults.validateStatus = function () {
  return true;
};
apigee.defaults.validateStatus = function () {
  return true;
};

apigeeApi.interceptors.request.use(
  async (conf: any) => {
    console.log("token : " + apigeeToken);
    conf.headers.Authorization = `Bearer ${apigeeToken}`;
    conf.headers["x-channel-id"] = "portal-digital-sales";
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);
apigee.interceptors.request.use(
  async (conf: any) => {
    console.log("token : " + bmToken);
    conf.headers.Authorization = `Bearer ${bmToken}`;
    conf.headers["x-channel-id"] = "portal-digital-sales";
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

apigeeApi.interceptors.response.use(
  async (response: any) => {

    return response;
  },
  async (error: any) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);
apigee.interceptors.response.use(
  async (response: any) => {

    return response;
  },
  async (error: any) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);

// get method
const getTrackOrder = async (orderNumber: string) => {
  //  const url = `http://localhost:3001/leadOrderDetails`;
  return apigeeApi.get(`${apigeeBaseURL}/SFAInquiry/v1?ID=${orderNumber}`);
};

const getCRNOrderDetails = async (crNumber: string) => {
  // const url = `http://localhost:3001/crnOrderDetails`;
  return apigeeApi.get(`${apigeeBaseURL}/v1/dp/r2r/digitalsalesretrival?crID=${crNumber}`);
}

const getLeadOrderDetails = async (leadId: string) => {
  return apigeeApi.get(`${apigeeBaseURL}/v1/dp/r2r/digitalsalesretrival?leadID=${leadId}`);
  // const url = `http://localhost:3001/leadOrderDetails`;
  // const url = `https://run.mocky.io/v3/6e24d333-f452-48a3-9c3e-a3d131a9c485`; // finger print
  // const url = `https://run.mocky.io/v3/b4353bf2-317d-401e-82da-d7c80dfb76a0`; //order creation
  // const url = `https://run.mocky.io/v3/e3adcb2a-beab-44c9-8e90-489406d40b81`; //order completed
}

const getAccountDetails = async (number: string) => {
  //number = 720755841
  if (number && number.toString().startsWith('700') || number && number.toString().startsWith('70')) {
    return apigeeApi.get(`${apigeeBaseURL}/SiebelInquiry/v1?CorporateIdentityID=${number}`)
  } else {
    return apigeeApi.get(`${apigeeBaseURL}/SiebelInquiry/v1?CommercialID=${number}`)
  }
}

// post method

const createOpportunityCombined = (data: any) => {
  return apigeeApi.post(`${apigeeBaseURL}/CrtOpportunityCombined/v1`, data);
};

const updateCreateOpportunityCombined = async (data: any) => {
  return apigee.post(`${apigeeBaseURL}/Update/CrtOpportunityCombined/v1`, data);
};


export { createOpportunityCombined, updateCreateOpportunityCombined, getTrackOrder, getLeadOrderDetails, getAccountDetails, getCRNOrderDetails };
